import "core-js/modules/es.array.includes.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { reactive, ref, watch, unref } from 'vue';
export default {
  __name: 'xFormPropView',
  props: {
    model: {
      type: Object,
      default: () => ({
        name: '表单名称',
        showPc: true,
        showMobile: true,
        size: 'medium',
        span: 24
      })
    },
    name: {
      type: String,
      default: '表单名称'
    },
    showPc: {
      type: Boolean,
      default: true
    },
    showMobile: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'medium',
      validator: v => ['small', 'medium', 'large'].includes(v)
    },
    span: {
      type: [Number, String],
      default: '24'
    }
  },
  emits: ['update:model'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const sizeOptions = ref([{
      value: 'medium',
      label: '常规'
    }, {
      value: 'small',
      label: '小'
    }, {
      value: 'mini',
      label: '迷你'
    }]);
    const formData = reactive({
      name: props.name,
      showPc: props.showPc,
      showMobile: props.showMobile,
      size: props.size,
      span: props.span
    });
    watch(() => props.model, val => {
      const {
        name: newName,
        showPc: newShowPc,
        showMobile: newShowMobile,
        size: newSize,
        span: newSpan
      } = unref(val);
      if (newName !== formData.name || newShowPc !== formData.showPc || newShowMobile !== formData.showMobile || newSize !== formData.size || newSpan !== formData.span) {
        Object.assign(formData, {
          name: newName,
          showPc: newShowPc,
          showMobile: newShowMobile,
          size: newSize,
          span: newSpan
        });
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => formData, val => {
      const {
        name,
        showPc,
        showMobile,
        size,
        span
      } = unref(val);
      console.log('form changed:', {
        name,
        showPc,
        showMobile,
        size,
        span
      });
      emit('update:model', {
        name,
        showPc,
        showMobile,
        size,
        span
      });
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_x_input = _resolveComponent("x-input");
      const _component_x_form_item = _resolveComponent("x-form-item");
      const _component_vxe_switch = _resolveComponent("vxe-switch");
      const _component_vxe_select = _resolveComponent("vxe-select");
      const _component_vxe_number_input = _resolveComponent("vxe-number-input");
      const _component_x_form = _resolveComponent("x-form");
      return _openBlock(), _createBlock(_component_x_form, {
        span: 24,
        data: formData
      }, {
        default: _withCtx(() => [_createVNode(_component_x_form_item, {
          title: "表单名称",
          field: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_x_input, {
            value: formData.name,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.name = $event)
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          span: 12,
          title: "显示PC端",
          field: "showPc"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_switch, {
            modelValue: formData.showPc,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.showPc = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          span: 12,
          title: "显示移动端",
          field: "showMobile"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_switch, {
            modelValue: formData.showMobile,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.showMobile = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          title: "组件大小",
          field: "size"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_select, {
            modelValue: formData.size,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.size = $event),
            options: sizeOptions.value
          }, null, 8, ["modelValue", "options"])]),
          _: 1
        }), _createVNode(_component_x_form_item, {
          title: "默认每项点列数",
          field: "span"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_number_input, {
            modelValue: formData.span,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.span = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]);
    };
  }
};